import axiosInstance from "../config/axios.config";

export const createMedicationApi = (payload) => {
  return axiosInstance.post(`/careservices/medication/`, payload);
};
export const updateMedicationApi = (med_id, payload) => {
  return axiosInstance.put(`/careservices/medication/${med_id}/`, payload);
};
export const getMedicationApi = (params) => {
  return axiosInstance.get(`/careservices/medication/?${params}`);
};
export const searchMedicationApi = (params) => {
  return axiosInstance.get(`/careservices/search/medication/?${params}`);
};
export const getGlobalMedicationApi = (params) => {
  return axiosInstance.get(`/careservices/get-global-medicines/?${params}`);
};
export function processAudioMedicationApi(formData) {
  return axiosInstance.post(
    "/careservices/ai-vision/process-audio-medications/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

/**
 * Cross-module search: patients, admissions, pharmacy orders and bills,
 * purchase entries and orders. Results come back grouped by `doc_type`, each
 * row sharing one shape - id, title, reference_id, subtitle, status.
 *
 * `signal` lets a caller abort a request its own keystroke has superseded.
 */
export const globalSearchApi = (query, { signal } = {}) => {
  return axiosInstance.get(
    `careservices/search/global/?q=${encodeURIComponent(query)}`,
    { signal }
  );
};
